import React from "react";
import { estadoVisible, mapaEstadosSolicitud } from "../utils/estados";

const PASOS = [
  { key: "nueva", texto: "Nueva" },
  { key: "en_cola", texto: "En cola" },
  { key: "cotizando", texto: "Cotizando" },
  { key: "pendiente_aprobacion", texto: "Esperando aprobación" },
  { key: "aprobada", texto: "Aprobada" },
  { key: "en_proceso_pago", texto: "Proceso de pago" },
  { key: "pagada", texto: "Pagada" },
  { key: "en_proceso_compra", texto: "Proceso de compra" },
  { key: "lista_para_retiro", texto: "Lista para retiro" },
  { key: "entregada", texto: "Recibida" },
];

function BarraProgreso({
  estado,
  totalCotizaciones,
  tienePendienteAprobacion,
  enAtencion,
  tienePagoPendiente,
  tienePagoRealizado,
}) {
  if (estado === "rechazada") {
    return (
      <div className="barra-progreso" style={styles.contenedor}>
        {PASOS.slice(0, 4).map((p, i) => (
          <React.Fragment key={p.key}>
            <div style={styles.paso}>
              <div style={{ ...styles.circulo, ...styles.circuloCompletado }}>✓</div>
              <span style={styles.etiqueta}>{p.texto}</span>
            </div>
            <div style={{ ...styles.linea, ...styles.lineaCompleta }} />
          </React.Fragment>
        ))}
        <div style={styles.paso}>
          <div style={{ ...styles.circulo, background: "#a3402f", borderColor: "#a3402f", color: "#fff" }}>
            ✕
          </div>
          <span style={{ ...styles.etiqueta, color: "#a3402f", fontWeight: 700 }}>Rechazada</span>
        </div>
      </div>
    );
  }

  const estadoEfectivo = estadoVisible(
    estado,
    totalCotizaciones,
    tienePendienteAprobacion,
    enAtencion,
    tienePagoPendiente,
    tienePagoRealizado
  );
  const indiceActual = PASOS.findIndex((p) => p.key === estadoEfectivo);
  // Al llegar a "Recibida" el proceso terminó: el último paso también va con su ✓.
  const finalizado = estadoEfectivo === "entregada";

  return (
    <div className="barra-progreso" style={styles.contenedor}>
      {PASOS.map((p, i) => (
        <React.Fragment key={p.key}>
          <div style={styles.paso}>
            <div
              style={{
                ...styles.circulo,
                ...(i < indiceActual || (finalizado && i === indiceActual) ? styles.circuloCompletado : {}),
                ...(i === indiceActual && !finalizado ? styles.circuloActual : {}),
              }}
            >
              {i < indiceActual || (finalizado && i === indiceActual) ? "✓" : i + 1}
            </div>
            <span style={{ ...styles.etiqueta, ...(i === indiceActual ? styles.etiquetaActual : {}) }}>
              {/* El último paso dice "Entregada" al personal y "Recibida" al solicitante. */}
              {p.key === "entregada" ? mapaEstadosSolicitud().entregada.texto : p.texto}
            </span>
          </div>
          {i < PASOS.length - 1 && (
            <div style={{ ...styles.linea, ...(i < indiceActual ? styles.lineaCompleta : {}) }} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

const styles = {
  contenedor: {
    display: "flex",
    alignItems: "flex-start",
    margin: "1.1rem 0 1.4rem",
    padding: "0.9rem 0.8rem 0.75rem",
    background: "#fff",
    border: "1px solid #e2e6ea",
    borderRadius: 14,
    boxShadow: "0 1px 3px rgba(27,42,74,0.06)",
  },
  paso: { display: "flex", flexDirection: "column", alignItems: "center", flex: "0 1 100px", minWidth: 54 },
  circulo: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid #d3d9df",
    background: "#fff",
    color: "#8993a1",
    fontSize: "0.76rem",
    fontWeight: 700,
    flexShrink: 0,
  },
  circuloCompletado: { background: "#2f7a54", borderColor: "#2f7a54", color: "#fff" },
  circuloActual: {
    background: "var(--tema-titulo, #0b3c60)",
    borderColor: "var(--tema-titulo, #0b3c60)",
    color: "#fff",
    boxShadow: "0 0 0 4px rgba(27,42,74,0.15)",
  },
  etiqueta: {
    fontSize: "0.68rem",
    color: "#5b6472",
    marginTop: "0.35rem",
    textAlign: "center",
    lineHeight: 1.2,
  },
  etiquetaActual: { color: "var(--tema-titulo, #0b3c60)", fontWeight: 700 },
  linea: { height: 2, flex: 1, minWidth: 4, background: "#d3d9df", marginTop: 13 },
  lineaCompleta: { background: "#2f7a54" },
};

export default BarraProgreso;
